// extracted by mini-css-extract-plugin
module.exports = {"main":"estructura_main__Grz_1"};